import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import Button from '../Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function ChangelogNoResult({ onClearFilter }) {
  const { t } = useTranslation()

  return (
    <div className={styles.changelogNoResult}>
      <div className={styles.changelogNoResultIcon}>
        <FontAwesomeIcon data-testid="search-icon" icon={['far', 'search']} />
      </div>

      <span>{t('changelog.page.notFound.title')}</span>
      <p>{t('changelog.page.notFound.subtitle')}</p>

      <Button onClick={onClearFilter} data-testid="changelog-clear-filter-button">
        {t('changelog.page.notFound.clearFilterCTA')}
      </Button>
    </div>
  )
}

export default ChangelogNoResult
